import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const HomePage = lazy(() => import('./HomePage'));
const SignupLoginPage = lazy(() => import('./SignupLoginPage'));
const PlanPrivate = lazy(() => import('./pages/PlanPrivate'));
const PlanO3Pro = lazy(() => import('./pages/PlanO3Pro'));
const PlanFamily = lazy(() => import('./pages/PlanFamily'));
const PlanStudent = lazy(() => import('./pages/PlanStudent'));
const PaymentCallback = lazy(() => import('./components/PaymentCallback'));
const BlogList = lazy(() => import('./pages/BlogList'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const AdminCodeVerifier = lazy(() => import('./pages/AdminCodeVerifier'));
const CodeTester = lazy(() => import('./pages/CodeTester'));

function GoogleAnalytics() {
  const location = useLocation();
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-LHYSKTSHFS', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <GoogleAnalytics />
        <div className="App">
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/signup" element={<SignupLoginPage />} />
              <Route path="/login" element={<SignupLoginPage />} />
              <Route path="/plans/private" element={<PlanPrivate />} />
              <Route path="/plans/o3pro" element={<PlanO3Pro />} />
              <Route path="/plans/family" element={<PlanFamily />} />
              <Route path="/plans/student" element={<PlanStudent />} />
              <Route path="/payment-callback" element={<PaymentCallback />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/admin/verify-code" element={<AdminCodeVerifier />} />
              <Route path="/test/code-generator" element={<CodeTester />} />
            </Routes>
          </Suspense>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
